import { flattenLocaleMessages } from '@mi-front/core';

import de from './messages/de.json';
import en from './messages/en.json';
import es from './messages/es.json';
import fr from './messages/fr.json';
import pt from './messages/pt.json';

export const uiLocaleMessages = {
  de: flattenLocaleMessages(de),
  en: flattenLocaleMessages(en),
  es: flattenLocaleMessages(es),
  fr: flattenLocaleMessages(fr),
  pt: flattenLocaleMessages(pt),
};
